<div class="login-container">

    <div class="logo-area">
        <img [src]="logoPath" alt="MSLA-ID" class="logo">
        <div class="subtitle">Your IDV Partner in Latin America</div>
    </div>

    <div class="login-card">
        <h2>Sign in to your account</h2>

        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">

            <div class="form-group">
                <label>Email</label>
                <div class="input-wrapper">
                    <input type="email" formControlName="email" placeholder="">
                    <mat-icon class="status-icon">vpn_key</mat-icon>
                </div>
            </div>

            <div class="form-group">
                <label>Password</label>
                <div class="input-wrapper">
                    <input type="password" formControlName="password" placeholder="">
                    <mat-icon class="status-icon">lock</mat-icon>
                </div>
            </div>

            <div class="error-msg" *ngIf="errorMessage">
                {{ errorMessage }}
            </div>

            <button type="submit" [disabled]="isLoading || loginForm.invalid">
                {{ isLoading ? 'Signing in...' : 'Sign in' }}
            </button>

        </form>
    </div>

    <div class="footer">
        2025 MSLA-ID a brand of MSLA International. All rights reserved @
    </div>
</div>